<!-- <template>
  <div>
    <a-modal width="50%" centered v-model="show" :title="$t('pdf')" :maskClosable="false" :okText="$t('print')"
      :cancelText="$t('cancel')" :cancelButtonProps="{ class: 'btn ts-whitespace-no-wrap btn-default' }"
      :confirmLoading="waiting" :footer="null" style="top: 3vh;" :zIndex="2000" @cancel="onCanel">
      <div id="container">
        <i class="fa fa-spinner spin fa-2x text-white" v-if="printing"></i>
        <iframe :src="src" v-if="!printing"></iframe>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'pdfPreview',
  props: ['value', 'invoiceId', 'template'],
  data() {
    return {
      show: false,
      waiting: false,
      printing: false,
      src: ''
    }
  },
  methods: {
    ...mapActions('martSale/order', ['previewPdf']),
    onCanel() {
      this.src = ''
      this.$emit('cancel', false)
    }
  },
  watch: {
    value: function (value) {
      if (value && this.invoiceId) {
        this.show = value
        this.printing = true
        this.previewPdf({
          stock_out_id: this.invoiceId,
          template: this.template
        })
          .then(response => {
            this.src = response.url
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => {
            this.printing = false
          })
      }
    }
  }
}
</script>

<style scoped>
#container {
  width: 100%;
  height: 70vh;
  background: black;
  text-align: center;
}

#container iframe {
  width: 100%;
  height: 70vh;
  border: 2px solid #acacac;
}

#container i {
  margin-top: 32vh;
}
</style> -->

<template>
  <div class="ts-mb-2">
    <div class="ts-border ts-rounded-md ts-mt-2 ts-p-3">
      <p class="ts-mb-0">Paper Size</p>
      <div>
        <a-radio-group name="paperSize" default-value="a5" v-model="model.paperSize">
          <a-radio value="a5">
            A5
          </a-radio>
          <a-radio value="e_receipt">
            Receipt
          </a-radio>
        </a-radio-group>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['value'],
  data() {
    return {
      model: {}
    }
  },
  created() {
    this.model = this.value
  }
}
</script>
